<mat-dialog-content class="dialog">
  <div class="content" *ngIf="profile">
    <h1 class="title">Herzlich Willkommen bei BringLiesel</h1>
    <div class="message">
      <mat-icon svgIcon="bringliesel-icon" class="bringliesel-icon"></mat-icon>
      <p>
        Wir freuen uns, dass Sie da sind!
        <br />
        Um mit BringLiesel loszulegen, überprüfen Sie bitte einmal Ihre
        Einrichtungsdaten, die wir für Sie bereits hinterlegt haben. Sollten Sie
        im Nachgang noch Änderungswünsche haben, können Sie dies auch jederzeit
        im Menü-Punkt „Einrichtungs-Profil“ vornehmen. Viel Freude beim Shoppen!
      </p>
    </div>
    <div class="sections">
      <app-main-info
        style="flex: 1"
        [profile]="profile"
        [formGroup]="customerForm.controls.mainInfo"></app-main-info>
      <app-primary-contact-info
        style="flex: 1"
        [profile]="profile"
        [formGroup]="
          customerForm.controls.primaryContact
        "></app-primary-contact-info>
    </div>
    <div class="sections">
      <app-delivery-billing-info
        style="flex: 1"
        [profile]="profile"
        [formGroup]="customerForm.controls.billing"></app-delivery-billing-info>
      <app-delivery-billing-info
        style="flex: 1"
        [profile]="profile"
        [isDelivery]="true"
        [formGroup]="
          customerForm.controls.delivery
        "></app-delivery-billing-info>
    </div>
    <div class="button-container">
      <app-button
        type="SAVE"
        text="Bestätigen"
        [action]="confirmCustomerData.bind(this)"
        [disabled]="isSaving"></app-button>
    </div>
  </div>
  <div *ngIf="isLoading" class="loader-container">
    <mat-spinner></mat-spinner>
  </div>
</mat-dialog-content>
